var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    function ListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "";
        return _this;
    }
    ListView.prototype.makeListView = function (id, items) {
        this.id = id;
        var html = "<div id=\"".concat(id, "\" class=\"list-view\">");
        items.forEach(function (value, key) {
            html += "<div class=\"list-view-item\" data-value=\"".concat(value, "\">").concat(key, "</div>");
        });
        html += "</div>";
        this.setHtml(html);
    };
    ListView.prototype.listenEvent = function (fn) {
        var _this = this;
        $("#".concat(this.id, " .list-view-item")).on('click', function (elm) {
            var target = $(elm.currentTarget);
            $("#".concat(_this.id, " .list-view-item")).removeClass('active');
            target.addClass('active');
            fn(target.data('value'));
        });
    };
    return ListView;
}(Gadget));
export { ListView };
